import { useEffect, useState } from "react";
import api from "./api";

const cache = new Map(); // username -> { at, value }
const waiting = new Map(); // username -> [resolve]
let timer = null;

const flush = async () => {
  timer = null;
  const names = [...waiting.keys()];
  const subs = new Map(waiting);
  waiting.clear();
  let data = {};
  try { data = (await api.get("/presence", { params: { u: names.join(",") } })).data || {}; } catch { /* offline */ }
  names.forEach((n) => {
    const v = data[n] ?? null;
    cache.set(n, { at: Date.now(), value: v });
    subs.get(n).forEach((r) => r(v));
  });
};

const lookup = (name) => new Promise((resolve) => {
  const hit = cache.get(name);
  if (hit && Date.now() - hit.at < 60000) return resolve(hit.value);
  if (!waiting.has(name)) waiting.set(name, []);
  waiting.get(name).push(resolve);
  if (!timer) timer = setTimeout(flush, 120);
});

export const usePresence = (username) => {
  const [p, setP] = useState(() => cache.get(username)?.value ?? null);
  useEffect(() => {
    if (!username) return;
    let alive = true;
    const run = () => lookup(username).then((v) => alive && setP(v));
    run();
    const t = setInterval(run, 60000);
    return () => { alive = false; clearInterval(t); };
  }, [username]);
  return p;
};

export const activeLabel = (p) => {
  if (!p) return null;
  if (p.online) return "Active now";
  if (!p.last_active) return null;
  const s = (Date.now() - new Date(p.last_active).getTime()) / 1000;
  if (s < 3600) return `Active ${Math.max(1, Math.floor(s / 60))}m ago`;
  if (s < 86400) return `Active ${Math.floor(s / 3600)}h ago`;
  if (s < 604800) return `Active ${Math.floor(s / 86400)}d ago`;
  return null;
};
